export const columnNames = {
    displayName: "Player",
    matches: "Games",
    rounds: "Rounds",
    ACS: "ACS",
    ADR: "ADR",
    APR: "APR",
    FDPR: "FDPR",
    FKPR: "FKPR",
    HS: "HS",
    KD: "KD",
    KPR: "KPR",
    survival: 'Survival',
    GameDuration: "Duration",
    teamName: "TeamName",
    enemyTeamName: "E Team",
    counterPick: "Counter Pick",
    winner: "WIN",
    totalWins: "WR%",
    scrimId: "Game N",
    gameId: "Game N",
    date: "Date",
    patch: "Patch",

    killsAndAssists8: "K+A@8",
    deaths8: "D@8",
    recalls8: "Recalls@8",

    goldDiff8: "GD@8",
    csDiff8: "CSD@8",
    expDiff8: "XPD@8",
    wardPlaced8: "WP@8",
    wardKilled8: "WK@8",
    visionScore8: "VS@8",

    killsAndAssists14: "K+A@14",
    deaths14: "D@14",
    recalls14: "Recalls@14",

    goldDiff14: "GD@14",
    csDiff14: "CSD@14",
    expDiff14: "XPD@14",
    wardPlaced14: "WP@14",
    wardKilled14: "WK@14",
    visionScore14: "VS@14",

    DMG15: "DMG/M@15",
    DMGShared15: "DMG%@15",
    dmgPerMinute15ToEnd: "DMG/M@15-End",
    DMGShared15end: "DMG%@15-End",
    DamageDealt: "DMG/M",

    damageShared: "DMG%",

    GD5: "GD@5",
    GD10: "GD@10",
    GD15: "GD@15",
    GOLD15: "GOLD/M@15",
    GOLDShared15: "GOLD%@15",
    goldPerMinute15ToEnd: "GOLD/M@15-End",
    GOLDShared15end: "GOLD% 15-End",
    GoldEarned: "G/M",
    goldShared: "G%",

    JungleProximity: "JGL%",
    JungleProximityEnd: "JGL% 15-End",
    enemyJungleProximity15: "eJGL% @15",
    enemyJungleProximityEnd: "eJGL% 15-End",

    soloKills: "solo K",
    kills: "K",
    deaths: "D",
    assists: "A",
    KDA: "KDA",
    recalls: "Recalls",


    wardPlaced: "WP",
    wardKilled: "WK",
    visionScore: "VS/M",
    wardPlacedPerMin: "WP/M",
    wardKilledPerMin: "WK/M",
    ControlWardsBoughtPerMin: "CWP/M",
    ControlWardsBought: "CWP",

    csDiff_0_5: "CSD 0-5",
    csDiff_5_10: "CSD 5-10",
    csDiff_10_15: "CSD 10-15",
    csDiff_0_15: "CSD 0-15",
    csDiff_20_end: "CSD 20-End",
    csPerMin_0_5: "CS/M@0-5",
    csPerMin_5_10: "CS/M@5-10",
    csPerMin_10_15: "CS/M@10-15",
    csPerMin_0_15: "CS/M@0-15",
    CS: "CS/M",

    TakenEnemyCamp4_7: "Enemy Camps Taken 4-7",
    IsolatedDeaths20plus: "Isolated Deaths 20+",
    TowerPlateDMG: "TDMG@14",

    soloKills: "soloKills",

    firstDeath: "First Death",
    firstLevel2: "First LVL 2",
    firstLevel6: "First LVL 6",
    level6Time: "LVL 6 Time",

    TopProximity: "TOP%",
    JglProximity: "JGL%",
    MidProximity: "MID%",
    BotProximity: "BOT%",
    SupProximity: "SUP%",
    winner: "WR%",
    firstBlood: "First Blood",

    feats: "Feats",
    featsEpic: "Feats Monster",
    featsKills: "Feats Kills",
    featsTower: "Feats Tower",


    firstVoidgrub: "First Void",
    voidGrubKilled: "VoidGrubs",
    firstHerald: "First Herald",

    firstDragon: "First Dragon",
    dragonsBefore14: "Dragons@14",
    dragonsAll14: "Dragons@14%",

    firstBaron: "First Baron",
    baronAll: "Barons %",

    firstAtakhan: "First Atakhan",


    firstTower: "First Turret",
    TopTurretPlates: "Top Plates",
    MidTurretPlates: "Mid Plates",
    BotTurretPlates: "Bot Plates",
    towersBefore14: "Towers@14",

    TeamGoldDiff8: "GD@8",
    TeamCsDiff8: "CSD@8",
    TeamExpDiff8: "XPD@8",
    TeamGoldDiff14: "GD@14",
    TeamCsDiff14: "CSD@14",
    TeamExpDiff14: "XPD@14",

    JungleProximity: "JGL%",
    DuoProximity: "BotDuo%",

    questTime: "Quest Time",
    firstQuest: "First Quest",

};


export const columnNamesDescription = {
    summonerName: "Summoner Name",
    Records: "Games",

    GameDuration: "Duration of the Games",
    championName: "Champion",
    enemyChampionName: "Enemy Champion",
    teamName: "TeamName",
    enemyTeamName: "Enemy Team",
    counterPick: "Counter Pick",
    winner: "WIN",
    totalWins: "Win Rate",
    scrimId: "Game Number",
    gameId: "Game Number",
    date: "Date",
    patch: "Patch",

    killsAndAssists8: "Kills + Assists at 8:00",
    deaths8: "Deaths at 8:00",
    recalls8: "Recalls at 8:00",

    goldDiff8: "Gold Difference at 8:00",
    csDiff8: "Creep Score Difference at 8:00",
    expDiff8: "Experience Difference at 8:00",
    wardPlaced8: "Wards Placed at 8:00",
    wardKilled8: "Wards Destroyed at 8:00",
    visionScore8: "Vision Score at 8:00",

    killsAndAssists14: "Kills + Assists at 14:00",
    deaths14: "Deaths at 14:00",
    recalls14: "Recalls at 14:00",

    goldDiff14: "Gold Difference at 14:00",
    csDiff14: "Creep Score Difference at 14:00",
    expDiff14: "Experience Difference at 14:00",
    wardPlaced14: "Wards Placed at 14:00",
    wardKilled14: "Wards Destroyed at 14:00",
    visionScore14: "Vision Score at 14:00",

    DMG15: "Damage per Minute at 15:00",
    DMGShared15: "Damage Share at 15:00",
    dmgPerMinute15ToEnd: "Damage per Minute from 15:00 to End",
    DMGShared15end: "Damage Share from 15:00 to End",
    DamageDealt: "Total Damage per Minute",

    damageShared: "Damage Share Percentage",

    GD5: "Gold Difference at 5:00",
    GD10: "Gold Difference at 10:00",
    GD15: "Gold Difference at 15:00",
    GOLD15: "Gold per Minute at 15:00",
    GOLDShared15: "Gold Share at 15:00",
    goldPerMinute15ToEnd: "Gold per Minute from 15:00 to End",
    GOLDShared15end: "Gold Share from 15:00 to End",
    GoldEarned: "Gold per Minute",
    goldShared: "Gold Share Percentage",

    JungleProximity: "Jungle Proximity (3-15 min)",
    JungleProximityEnd: "Jungle Proximity (15 min to End)",
    enemyJungleProximity15: "Enemy Jungle Proximity (3-15 min)",
    enemyJungleProximityEnd: "Enemy Jungle Proximity (15 min to End)",

    soloKills: "Total Solo Kills",
    kills: "Total Kills",
    deaths: "Total Deaths",
    assists: "Total Assists",
    KDA: "Kill/Death/Assist Ratio",
    recalls: "Recalls",

    wardPlaced: "Total Wards Placed",
    wardKilled: "Total Wards Destroyed",
    visionScore: "Vision Score per Minute",
    wardPlacedPerMin: "Total Wards Placed per Minute",
    wardKilledPerMin: "Total Wards Destroyed per Minute",
    ControlWardsBoughtPerMin: "Control Wards Purchased per Minute",
    ControlWardsBought: "Control Wards Purchased",

    csDiff_0_5: "Creep Score Difference (0-5 min)",
    csDiff_5_10: "Creep Score Difference (5-10 min)",
    csDiff_10_15: "Creep Score Difference (10-15 min)",
    csDiff_0_15: "Creep Score Difference (0-15 min)",
    csDiff_20_end: "Creep Score Difference (20 min to End)",
    csPerMin_0_5: "Creep Score per Minute (0-5 min)",
    csPerMin_5_10: "Creep Score per Minute (5-10 min)",
    csPerMin_10_15: "Creep Score per Minute (10-15 min)",
    csPerMin_0_15: "Creep Score per Minute (0-15 min)",
    CS: "Overall Creep Score per Minute",

    TakenEnemyCamp4_7: "Enemy Camps Taken (4-7 min)",
    IsolatedDeaths20plus: "Isolated Deaths after 20 min",
    TowerPlateDMG: "Tower Damage at 14:00",
    firstDeath: "First Death in the game",

    firstLevel2: "First to Level 2",
    firstLevel6: "First to Level 6",
    level6Time: "Time of getting level 6",

    TopProximity: "Proximity of the Player to TOP",
    JglProximity: "Proximity of the Player to JGL",
    MidProximity: "Proximity of the Player to MID",
    BotProximity: "Proximity of the Player to BOT",
    SupProximity: "Proximity of the Player to SUP",

    firstBlood: "First Kill",

    feats: "First to 2 Feats",
    featsEpic: "First to kill 3 Epic Monsters",
    featsKills: "First to get 3 Kills",
    featsTower: "First to get Tower",


    firstVoidgrub: "First Voidgrub",
    voidGrubKilled: "Amount of VoidGrubs killed",
    firstHerald: "First to kill Herald",

    firstDragon: "First Dragon",
    dragonsBefore14: "Dragons@14",
    dragonsAll14: "Dragons@14%",

    firstBaron: "First Baron",
    baronAll: "Barons Shared",

    firstAtakhan: "First Atakhan",


    firstTower: "First Turret",
    TopTurretPlates: "Top Plates",
    MidTurretPlates: "Mid Plates",
    BotTurretPlates: "Bot Plates",
    towersBefore14: "Towers killed at 14:00",


    TeamGoldDiff8: "Gold Difference at 8:00",
    TeamCsDiff8: "Creep Score Difference at 8:00",
    TeamExpDiff8: "Experience Difference at 8:00",
    TeamGoldDiff14: "Gold Difference at 8:00",
    TeamCsDiff14: "Creep Score Difference at 14:00",
    TeamExpDiff14: "Experience Difference at 14:00",

    JungleProximity: "Time that the jungler spent near atleast 1 teammate",
    DuoProximity: "Time that Botlane spent together till 15 min",
    questTime: "Quest Time Completion",
    firstQuest: "First Quest in that Role",
    blueWins: "Win rate on blue side of the map",
    redWins: "Win rate on red side of the map"
}
